import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useGigs() {
  const { baseurl, token, accessToken, setIsUnauthorised, AdminId } =
    useGlobalContext();

  // ---------- GET SLOTS ----------
  const fetchSlotsApi = async (date, setSlotsData, setFilteredData, setLoading) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v2.0/getSlotsList`,
        { date, adminId: AdminId },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        const [year, month, day] = date.split("-");
        const months = [
          "JAN","FEB","MAR","APR","MAY","JUN",
          "JUL","AUG","SEP","OCT","NOV","DEC",
        ];
        const jsDate = new Date(year, month - 1, day);
        const dayName = jsDate
          .toLocaleDateString("en-US", { weekday: "long" })
          .toUpperCase();

        const formattedDate = `${day} ${months[month - 1]}, ${dayName}`;

        const filtered = (res.data.data || []).filter(
          (slot) => slot.slot_date.toUpperCase() === formattedDate
        );

        setSlotsData(filtered);
        setFilteredData(filtered);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch slots");
        setSlotsData([]);
      }
    } catch {
      toast.error("Error fetching slots");
    } finally {
      setLoading(false);
    }
  };

  // ---------- DELETE SLOT ----------
  const deleteSlotApi = async (slotId, onSuccess) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteSlot`,
        { slotId, adminId: AdminId },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (res.data.responseCode === "00") {
        toast.success("Slot deleted successfully");
        onSuccess?.();
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to delete slot");
      }
    } catch {
      toast.error("Error deleting slot");
    }
  };

  // ---------- GET BOOKED DRIVERS ----------
  const fetchBookedDriversApi = async (
    slotId,
    setDriverList,
    setDriverListLoading
  ) => {
    setDriverListLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getSlotBookedDriverList`,
        { slotId, adminId: AdminId },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        setDriverList(res.data.data || []);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch drivers");
        setDriverList([]);
      }
    } catch {
      toast.error("Error fetching driver list");
    } finally {
      setDriverListLoading(false);
    }
  };

  return {
    fetchSlotsApi,
    deleteSlotApi,
    fetchBookedDriversApi,
  };
}
